// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_gf-0";
export var headerCellHover = "_gf-1";
export var readCellContainer = "_gf-2";
export var unreadIndicator = "_gf-3";